import type { KeyOfType } from '@ipfabric/utils';
import type { Viewport } from 'pixi-viewport';

/**
 * pixi-viewport currently does not emit zoom events when
 * zoom is changed programmatically. This patch installs a wrapper
 * to methods that change zoom so that they emit zoomed and zoomed-end.
 * @see https://github.com/davidfig/pixi-viewport/issues/241
 */
export function installEventsOnManualZoomChanges(viewport: Viewport): void {
  const zoomingFunctions: KeyOfType<Viewport, (...args: any) => any>[] = [
    'setZoom',
    'fitWidth',
    'fitHeight',
    'fitWorld',
    'fit',
  ];
  for (const zoomingFunctionName of zoomingFunctions) {
    const oldFunction = viewport[zoomingFunctionName].bind(viewport);
    viewport[zoomingFunctionName] = (...args: any[]) => {
      const prevX = viewport.scale.x;
      const prevY = viewport.scale.y;
      const result = (oldFunction as any)(...args);
      if (prevX !== viewport.scale.x || prevY !== viewport.scale.y) {
        (viewport as any).zooming = true; // makes viewport emit zoomed-end when appropriate
        viewport.emit('zoomed', { viewport, type: 'manual' });
      }
      return result;
    };
  }
}
